var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreTrend = function SvgMoreTrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "inherit"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.302 10.605A.7.7 0 0 0 19 9.907V7.802a.7.7 0 0 0-.698-.697h-2.104a.7.7 0 0 0-.698.697c0 .383.315.698.698.698h.405l-3.905 3.905-1.61-1.61a.706.706 0 0 0-.99 0l-3.703 3.703v-8.8A.7.7 0 0 0 5.699 5 .7.7 0 0 0 5 5.698v11.197C5 18.056 5.945 19 7.105 19h11.197a.7.7 0 0 0 .698-.698.7.7 0 0 0-.698-.697H7.105a.7.7 0 0 1-.698-.698v-.405l4.198-4.198 1.609 1.61c.27.27.72.27.99 0l4.4-4.401v.405c0 .383.316.698.698.698z"
  })));
};
export default SvgMoreTrend;